import { useProcess } from '@fasstech/oip-starter-utils/app';
import { compose, equals, none, propOr } from 'ramda';

const displayExtraEmailButton = () => {
  const { context } = useProcess();

  const creatorUserHasNoBrokerRole = compose(
    none(equals('BROKER')),
    propOr([], 'creatorUserRoles')
  )(context);

  return creatorUserHasNoBrokerRole;
};

export default displayExtraEmailButton;
